'use strict';

/**
 * General http service using resource to reduce boilerplate code
 */
module.exports = (app) => app.factory('workflowService', /* @ngInject */ function (apiConfig, httpService) {
    return {
        showTaskAfterOrderCompletion: () => {
            const uri = apiConfig.getBase('workflow', 'setting', 'post-order-task');
            return httpService.get(uri.toString(), {
                transformResponse: function (showTask) {
                    return {
                        showTask: showTask === 'true'
                    }
                },
            })
        }
    }
})
